angular
    .module('empower.policy', ['policy.controller', 'policy.service'])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            // .when('/policy-payment/:policyId?', {
            //     templateUrl: 'module/policy/view/policy-payment.html',
            //     controller:'policyPaymentController'
            // })
            .when('/policy-claim-search',{
                templateUrl: 'module/policy/view/policy-claim-search.html',
                controller: 'policyClaimSearchController'
            });
    }]);